import React, { CSSProperties } from 'react';
import './skeleton-loader.scss';

const SkeletonLoader = ({ style = {}, num = 1 }: { style?: CSSProperties; num?: number }) => {
  return (
    <div className="skeleton-loader">
      {Array.from({ length: num }).map((_, i) => (
        <div key={i} className="skeleton-item rounded-lg" style={style} />
      ))}
    </div>
  );
};

export default SkeletonLoader;
